<!-- Support → Levelezés / Beszerzés → Levelezés: lista · beszélgetés · kapcsolatok -->
<div class="sml">

  <div class="sml__head">
    <div class="sml__head-text">
      <h1 class="stk-page-title">{{ purchasing ? 'Beszerzési levelezés' : 'Levelezés' }}</h1>
      <div class="stk-page-sub">
        <ng-container *ngIf="settings?.configured; else notConfigured">
          {{ settings?.email }}
          <span *ngIf="settings?.last_sync_at"> · frissítve {{ shortTime(settings!.last_sync_at!) }}</span>
          <span class="sml__sync-error" *ngIf="settings?.last_sync_error" [title]="settings!.last_sync_error!"> · a postafiók nem érhető el</span>
          <span class="sml__sync-off" *ngIf="!settings?.enabled"> · az automatikus fogadás ki van kapcsolva</span>
        </ng-container>
        <ng-template #notConfigured>{{ canEditMailbox ? (purchasing ? 'Állítsd be a beszerzési postafiókot (beszerzes@) — a szervereket a support postafiókból előre kitöltöttük.' : 'Állítsd be a support postafiókot a levelek fogadásához és küldéséhez.') : (purchasing ? 'A beszerzési postafiók még nincs beállítva — kérd meg az adminisztrátort.' : 'A support postafiók még nincs beállítva — kérd meg az adminisztrátort.') }}</ng-template>
      </div>
    </div>
    <button type="button" class="sml-btn" (click)="syncNow()" [disabled]="syncing || !settings?.configured" title="Új levelek lekérése most">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.sml-spin]="syncing"><path d="M20 11 a8 8 0 1 0 -2.3 5.7"></path><polyline points="20,4 20,11 13,11"></polyline></svg>
      {{ syncing ? 'Frissítés…' : 'Frissítés' }}
    </button>
    <button type="button" class="sml-btn" (click)="openPartners()" title="Partnerek címjegyzéke (futárok, beszállítók)">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8.5" r="3"></circle><path d="M3.5 19 a5.5 5.5 0 0 1 11 0"></path><circle cx="17" cy="8" r="2.4"></circle><path d="M15 14.5 a5 5 0 0 1 5.5 4.5"></path></svg>
      Partnerek
    </button>
    <button type="button" class="sml-btn" *ngIf="canEditMailbox" (click)="openSettings()" title="Postafiók és aláírás">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="8" x2="20" y2="8"></line><circle cx="9" cy="8" r="2.4" fill="#fff"></circle><line x1="4" y1="16" x2="20" y2="16"></line><circle cx="15" cy="16" r="2.4" fill="#fff"></circle></svg>
      Beállítások
    </button>
    <button type="button" class="sml-btn sml-btn--primary" (click)="openCompose()" [disabled]="!settings?.configured">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20 l4 -1 l11 -11 a1.5 1.5 0 0 0 0 -2.2 l-0.8 -0.8 a1.5 1.5 0 0 0 -2.2 0 L5 16 z"></path></svg>
      Új levél
    </button>
  </div>

  <div class="sml__grid" [class.sml__grid--thread]="!!thread || loadingThread">

    <!-- 1. hasáb: beszélgetések -->
    <aside class="sml-list">
      <div class="sml-list__tools">
        <input class="sml-input" type="search" [ngModel]="search" (ngModelChange)="onSearchChange($event)"
               placeholder="Keresés: név, e-mail, tárgy, L-szám…">
        <div class="sml-list__filters">
          <button type="button" class="sml-chip" *ngFor="let f of filters" [class.sml-chip--on]="filter === f.key" (click)="setFilter(f.key)">{{ f.label }}</button>
        </div>
      </div>
      <div class="sml-list__items">
        <div class="sml-row" *ngFor="let t of threads; trackBy: trackThread" [class.sml-row--on]="thread?.id === t.id"
             [class.sml-row--unread]="t.unread" (click)="openThread(t)">
          <span class="sml-avatar" [style.background]="colorOf(whoOf(t))">{{ initialOf(whoOf(t)) }}</span>
          <div class="sml-row__main">
            <div class="sml-row__top">
              <span class="sml-row__who">{{ whoOf(t) }}</span>
              <span class="sml-row__time">{{ shortTime(t.lastMessageAt) }}</span>
            </div>
            <div class="sml-row__subject">{{ t.subject }}</div>
            <div class="sml-row__preview"><span *ngIf="t.lastDirection === 'out'" class="sml-row__me">Te: </span>{{ t.preview }}</div>
            <div class="sml-row__meta">
              <span class="sml-id">{{ t.displayId }}</span>
              <span class="sml-tag sml-tag--partner" *ngIf="t.partnerName" title="Partner a címjegyzékből">{{ t.partnerName }}</span>
              <span class="sml-tag sml-tag--wait" *ngIf="t.status === 'open' && t.lastDirection === 'in'">válaszra vár</span>
              <span class="sml-tag sml-tag--spam" *ngIf="t.status === 'spam'">spam</span>
              <span class="sml-tag" *ngIf="t.status === 'closed'">lezárva</span>
              <span class="sml-row__spacer"></span>
              <span class="sml-row__count" *ngIf="t.orderCount" title="Kapcsolt rendelés">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3,4 6,4 8.4,14.5 18.6,14.5 20.6,7.5 7.2,7.5"></polyline><circle cx="9.4" cy="19" r="1.5"></circle><circle cx="17.4" cy="19" r="1.5"></circle></svg>{{ t.orderCount }}
              </span>
              <span class="sml-row__count" *ngIf="t.ticketCount" title="Kapcsolt task">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="3"></rect><polyline points="8,12.5 11,15.5 16,9"></polyline></svg>{{ t.ticketCount }}
              </span>
            </div>
          </div>
        </div>
        <div class="sml-empty" *ngIf="!loadingList && threads.length === 0">
          {{ search ? 'Nincs találat.' : (filter === 'open' ? 'Nincs nyitott beszélgetés.' : filter === 'spam' ? 'A Spam mappa üres.' : filter === 'partner' ? 'Nincs nyitott beszélgetés partnerrel.' : 'Nincs ilyen beszélgetés.') }}
        </div>
        <div class="sml-empty" *ngIf="loadingList && threads.length === 0">Betöltés…</div>
        <div class="sml-list__more" *ngIf="total > threads.length">{{ threads.length }} / {{ total }} — szűkítsd kereséssel.</div>
      </div>
    </aside>

    <!-- 2. hasáb: beszélgetés -->
    <section class="sml-conv">
      <div class="sml-conv__placeholder" *ngIf="!thread && !loadingThread">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#B4BAA6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"></rect><polyline points="3,7 12,13 21,7"></polyline></svg>
        <div>Válassz egy beszélgetést a listából.</div>
      </div>
      <div class="sml-conv__placeholder" *ngIf="loadingThread">Betöltés…</div>

      <ng-container *ngIf="thread && !loadingThread">
        <div class="sml-conv__head">
          <button type="button" class="sml-icon-btn sml-conv__back" title="Vissza a listához" (click)="closeThreadView()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15,5 8,12 15,19"></polyline></svg>
          </button>
          <div class="sml-conv__head-main">
            <div class="sml-conv__subject">{{ thread.subject }}</div>
            <div class="sml-conv__sub"><span class="sml-id">{{ thread.displayId }}</span> · {{ thread.customerName ? thread.customerName + ' · ' : '' }}{{ thread.customerEmail }}</div>
          </div>
          <ng-container *ngIf="thread.status !== 'spam'">
            <button type="button" class="sml-btn sml-btn--sm" (click)="markUnread()" title="Olvasatlannak jelöl és bezár">Olvasatlan</button>
            <button type="button" class="sml-btn sml-btn--sm sml-btn--spam" (click)="setSpam(true)" title="Áttesz a Spam mappába (nem a lezártak közé)">Spam</button>
            <button type="button" class="sml-btn sml-btn--sm" [class.sml-btn--done]="thread.status === 'open'" (click)="toggleStatus()">
              {{ thread.status === 'open' ? 'Lezárás' : 'Újranyitás' }}
            </button>
          </ng-container>
          <button type="button" class="sml-btn sml-btn--sm" *ngIf="thread.status === 'spam'" (click)="setSpam(false)">Nem spam</button>
        </div>

        <!-- Spam sáv: a feladó tiltása itt kapcsolható -->
        <div class="sml-spambar" *ngIf="thread.status === 'spam'">
          <span class="sml-spambar__text">
            Ez a beszélgetés a <strong>Spam</strong> mappában van.
            {{ thread.senderBlocked ? 'A feladó tiltva van: az új levelei is egyenesen ide érkeznek.' : 'A feladó új levelei továbbra is a beérkezők közé jönnek.' }}
          </span>
          <button type="button" class="sml-btn sml-btn--sm" *ngIf="!thread.senderBlocked" (click)="setSenderBlocked(true)">Feladó tiltása</button>
          <button type="button" class="sml-btn sml-btn--sm" *ngIf="thread.senderBlocked" (click)="setSenderBlocked(false)">Tiltás feloldása</button>
        </div>

        <div class="sml-conv__messages" #messagesEl>
          <div class="sml-msg" *ngFor="let m of thread.messages; trackBy: trackMessage" [class.sml-msg--out]="m.direction === 'out'">
            <div class="sml-msg__head">
              <span class="sml-avatar sml-avatar--sm" [style.background]="m.direction === 'out' ? '#8FB859' : colorOf(senderOf(m))">{{ initialOf(senderOf(m)) }}</span>
              <span class="sml-msg__who">{{ senderOf(m) }}</span>
              <span class="sml-msg__to" [title]="recipientsOf(m)">→ {{ recipientsOf(m) }}</span>
              <span class="sml-msg__time">{{ fullTime(m.sentAt) }}</span>
            </div>
            <iframe class="sml-msg__frame" *ngIf="m.html" [srcdoc]="frameDoc(m)" (load)="fitFrame($event)"
                    sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox" referrerpolicy="no-referrer" title="Levél"></iframe>
            <div class="sml-msg__text" *ngIf="!m.html">{{ m.text }}</div>
            <div class="sml-msg__files" *ngIf="m.attachments.length">
              <button type="button" class="sml-file" *ngFor="let a of m.attachments" (click)="download(a)" [title]="'Letöltés: ' + a.fileName">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 11.5 l-8 8 a5 5 0 0 1 -7 -7 l8.5 -8.5 a3.4 3.4 0 0 1 4.8 4.8 L10 17 a1.7 1.7 0 0 1 -2.4 -2.4 l7.4 -7.4"></path></svg>
                <span class="sml-file__name">{{ a.fileName }}</span>
                <span class="sml-file__size">{{ sizeLabel(a.size) }}</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Válasz -->
        <div class="sml-reply">
          <div class="sml-reply__to">
            <span>Válasz: <strong>{{ thread.customerEmail }}</strong></span>
            <button type="button" class="sml-link" *ngIf="!replyCcOpen" (click)="replyCcOpen = true">+ másolat</button>
            <span class="sml-reply__note">{{ settings?.signature ? 'Az aláírás automatikusan a levél végére kerül.' : 'Nincs aláírás beállítva.' }}</span>
          </div>
          <input class="sml-input sml-reply__cc" *ngIf="replyCcOpen" [(ngModel)]="replyCc" placeholder="Másolatot kap (vesszővel elválasztva)">
          <textarea class="sml-input sml-reply__text" rows="5" [(ngModel)]="replyText" (keydown)="onReplyKeydown($event)"
                    placeholder="Írd meg a választ… (Ctrl + Enter = küldés)"></textarea>
          <div class="sml-msg__files" *ngIf="replyFiles.length">
            <span class="sml-file sml-file--pending" *ngFor="let f of replyFiles; index as i">
              <span class="sml-file__name">{{ f.name }}</span>
              <span class="sml-file__size">{{ sizeLabel(f.size) }}</span>
              <button type="button" class="sml-file__del" title="Eltávolítás" (click)="removeReplyFile(i)">×</button>
            </span>
          </div>
          <div class="sml-reply__actions">
            <label class="sml-btn sml-btn--sm" title="Fájl csatolása (legfeljebb 15 MB / fájl)">
              <input type="file" multiple hidden (change)="onReplyFiles($event)">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 11.5 l-8 8 a5 5 0 0 1 -7 -7 l8.5 -8.5 a3.4 3.4 0 0 1 4.8 4.8 L10 17 a1.7 1.7 0 0 1 -2.4 -2.4 l7.4 -7.4"></path></svg>
              Csatolás
            </label>
            <span class="sml-reply__spacer"></span>
            <button type="button" class="sml-btn sml-btn--sm" [disabled]="sending || !replyText.trim()" (click)="sendReply(true)">Küldés és lezárás</button>
            <button type="button" class="sml-btn sml-btn--sm sml-btn--primary" [disabled]="sending || !replyText.trim()" (click)="sendReply()">{{ sending ? 'Küldés…' : 'Küldés' }}</button>
          </div>
        </div>
      </ng-container>
    </section>

    <!-- 3. hasáb: kapcsolatok -->
    <aside class="sml-side" *ngIf="thread && !loadingThread">
      <div class="sml-box">
        <div class="sml-box__kicker">{{ purchasing ? 'Beszállító' : 'Vevő' }}</div>
        <div class="sml-side__customer">
          <span class="sml-avatar" [style.background]="colorOf(whoOf(thread))">{{ initialOf(whoOf(thread)) }}</span>
          <div class="sml-side__customer-main">
            <div class="sml-side__customer-name">{{ whoOf(thread) }}</div>
            <div class="sml-side__customer-mail">{{ thread.customerEmail }}</div>
          </div>
        </div>
        <div class="sml-side__facts">{{ thread.messageCount }} üzenet · {{ thread.status === 'open' ? 'nyitott' : thread.status === 'spam' ? 'spam' : 'lezárt' }}{{ thread.senderBlocked ? ' · tiltott feladó' : '' }}</div>
        <div class="sml-side__partner" *ngIf="thread.partner as partner">
          <span class="sml-tag sml-tag--partner">Partner</span> {{ partner.name }}
          <div class="sml-link-item__meta" *ngIf="partner.note">{{ partner.note }}</div>
        </div>
        <ng-container *ngIf="!thread.partner && thread.status !== 'spam'">
          <button type="button" class="sml-link sml-side__partner-add" *ngIf="quickPartnerName === null"
                  (click)="quickPartnerName = thread.customerName || ''">+ Mentés a partnerek közé</button>
          <form class="sml-task__row" *ngIf="quickPartnerName !== null" (ngSubmit)="saveQuickPartner()">
            <input class="sml-input sml-input--sm" name="quickPartner" [(ngModel)]="quickPartnerName" placeholder="Partner neve (pl. UPS)" maxlength="255" autocomplete="off">
            <button type="submit" class="sml-btn sml-btn--sm sml-btn--primary" [disabled]="partnerSaving || !quickPartnerName.trim()">Mentés</button>
            <button type="button" class="sml-icon-btn" title="Mégse" (click)="quickPartnerName = null">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
            </button>
          </form>
        </ng-container>
      </div>

      <div class="sml-box" *ngIf="purchasing">
        <div class="sml-box__kicker">Beszerzési rendelések</div>
        <div class="sml-link-item" *ngFor="let o of threadOrders">
          <div class="sml-link-item__row">
            <a class="sml-link-item__main" [routerLink]="['/beszerzes/rendelesek']" [queryParams]="{ po: o.id }" title="Rendelés megnyitása">
              <div class="sml-link-item__title">{{ o.displayId }} · {{ o.supplier?.name }}</div>
              <div class="sml-link-item__meta">{{ o.statusLabel }}<ng-container *ngIf="o.grossTotal !== null"> · {{ o.grossTotal | number:'1.0-0' }} Ft</ng-container></div>
            </a>
          </div>
        </div>
        <div class="sml-box__hint" *ngIf="!threadOrders.length">Ez a levél még nincs rendeléshez kötve — Foxi a beszállító válaszait magától hozzáköti.</div>
      </div>

      <div class="sml-box" *ngIf="!purchasing">
        <div class="sml-box__kicker">Rendelések</div>
        <div class="sml-link-item" *ngFor="let o of thread.orders">
          <div class="sml-link-item__row">
            <div class="sml-link-item__main" (click)="openOrder(o)" title="Rendelés megnyitása">
              <div class="sml-link-item__title">{{ o.displayId }} · {{ o.customerName }}</div>
              <div class="sml-link-item__meta">{{ o.shop }}</div>
            </div>
            <button type="button" class="sml-icon-btn" title="Leválasztás" (click)="removeOrder(o)">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
            </button>
          </div>
          <app-tracking-panel [orderId]="o.orderId" [compact]="true"></app-tracking-panel>
        </div>

        <ng-container *ngIf="thread.suggestedOrders.length">
          <div class="sml-box__hint">A vevő e-mail címe alapján:</div>
          <div class="sml-suggest" *ngFor="let o of thread.suggestedOrders" (click)="addOrder(o)" title="Hozzáadás a beszélgetéshez">
            <span class="sml-suggest__plus">+</span>
            <div class="sml-link-item__main">
              <div class="sml-link-item__title">{{ o.displayId }} · {{ o.customerName }}</div>
              <div class="sml-link-item__meta">{{ o.shop }}</div>
            </div>
          </div>
        </ng-container>

        <input class="sml-input sml-input--sm" [ngModel]="orderSearch" (ngModelChange)="onOrderSearchChange($event)" placeholder="Rendelés keresése: név vagy order ID…">
        <div class="sml-results" *ngIf="orderResults.length">
          <div class="sml-results__item" *ngFor="let o of orderResults" (click)="addOrder(o)">
            <div class="sml-link-item__title">{{ o.customerName }}</div>
            <div class="sml-link-item__meta">{{ o.displayId }} · {{ o.shop }}</div>
          </div>
        </div>
      </div>

      <div class="sml-box" *ngIf="!purchasing">
        <div class="sml-box__kicker">Taskok</div>
        <div class="sml-link-item" *ngFor="let k of thread.tickets">
          <div class="sml-link-item__row">
            <div class="sml-link-item__main" (click)="openTicket(k)" title="Task megnyitása">
              <div class="sml-link-item__title"><span class="sml-id">{{ k.displayId }}</span> {{ k.title }}</div>
              <div class="sml-link-item__meta">{{ k.status }} · {{ k.priority }}</div>
            </div>
            <button type="button" class="sml-icon-btn" title="Leválasztás" (click)="removeTicket(k)">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
            </button>
          </div>
        </div>

        <button type="button" class="sml-btn sml-btn--block" *ngIf="!taskForm" (click)="openTaskForm()">+ Task nyitása a beszélgetésből</button>
        <form class="sml-task" *ngIf="taskForm" (ngSubmit)="createTask()">
          <input class="sml-input sml-input--sm" name="taskTitle" [(ngModel)]="taskForm.title" placeholder="Task címe…" maxlength="255" autocomplete="off">
          <div class="sml-task__row">
            <button type="button" class="sml-chip" *ngFor="let p of prioKeys" [class.sml-chip--on]="taskForm.priority === p" (click)="taskForm.priority = p">{{ p }}</button>
            <select class="sml-input sml-input--sm sml-task__status" name="taskStatus" [(ngModel)]="taskForm.status">
              <option *ngFor="let c of columns" [ngValue]="c.name">{{ c.name }}</option>
            </select>
          </div>
          <div class="sml-box__hint" *ngIf="thread.orders.length">A task megkapja a(z) {{ thread.orders[0].displayId }} rendelést is.</div>
          <div class="sml-task__actions">
            <button type="button" class="sml-btn sml-btn--sm" (click)="taskForm = null" [disabled]="taskSaving">Mégse</button>
            <button type="submit" class="sml-btn sml-btn--sm sml-btn--primary" [disabled]="taskSaving || !taskForm.title.trim()">{{ taskSaving ? 'Mentés…' : 'Létrehozás' }}</button>
          </div>
        </form>

        <input class="sml-input sml-input--sm" [ngModel]="ticketSearch" (ngModelChange)="onTicketSearchChange($event)" placeholder="Meglévő task: T-szám vagy cím…">
        <div class="sml-results" *ngIf="ticketResults.length">
          <div class="sml-results__item" *ngFor="let k of ticketResults" (click)="addTicket(k)">
            <div class="sml-link-item__title">{{ k.displayId }} · {{ k.title }}</div>
            <div class="sml-link-item__meta">{{ k.status }} · {{ k.priority }}</div>
          </div>
        </div>
      </div>
    </aside>
  </div>

  <!-- Új levél -->
  <div class="sml-overlay" *ngIf="compose">
    <form class="sml-modal" (ngSubmit)="sendCompose()">
      <div class="sml-modal__head">
        <span class="sml-modal__title">Új levél</span>
        <span class="sml-modal__from" *ngIf="settings?.email">Feladó: {{ settings?.email }}</span>
        <button type="button" class="sml-icon-btn" title="Bezárás" (click)="compose = null" [disabled]="sending">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
        </button>
      </div>
      <div class="sml-modal__body">
        <input class="sml-input" name="composeTo" [(ngModel)]="compose.to" placeholder="Címzett e-mail címe — vagy kezdd el írni egy partner nevét" autocomplete="off">
        <div class="sml-partner-picks" *ngIf="composeSuggestions.length">
          <button type="button" class="sml-chip sml-chip--partner" *ngFor="let p of composeSuggestions" [title]="p.email + (p.note ? ' — ' + p.note : '')" (click)="pickComposePartner(p)">{{ p.name }}</button>
        </div>
        <div class="sml-partner-save" *ngIf="compose.to.trim() && !composeToIsPartner && !composeSuggestions.length">
          <label class="sml-check"><input type="checkbox" name="composeSavePartner" [(ngModel)]="compose.saveAsPartner"> Címzett mentése a partnerek közé</label>
          <input class="sml-input sml-input--sm" *ngIf="compose.saveAsPartner" name="composePartnerName" [(ngModel)]="compose.partnerName" placeholder="Partner neve (pl. Spring GDS)" maxlength="255" autocomplete="off">
        </div>
        <input class="sml-input" name="composeCc" [(ngModel)]="compose.cc" placeholder="Másolat (nem kötelező, vesszővel elválasztva)" autocomplete="off">
        <input class="sml-input" name="composeSubject" [(ngModel)]="compose.subject" placeholder="Tárgy" maxlength="250" autocomplete="off">
        <textarea class="sml-input sml-modal__text" name="composeText" rows="10" [(ngModel)]="compose.text" placeholder="Üzenet…"></textarea>
        <div class="sml-msg__files" *ngIf="compose.files.length">
          <span class="sml-file sml-file--pending" *ngFor="let f of compose.files; index as i">
            <span class="sml-file__name">{{ f.name }}</span>
            <span class="sml-file__size">{{ sizeLabel(f.size) }}</span>
            <button type="button" class="sml-file__del" title="Eltávolítás" (click)="removeComposeFile(i)">×</button>
          </span>
        </div>
      </div>
      <div class="sml-modal__foot">
        <label class="sml-btn sml-btn--sm">
          <input type="file" multiple hidden (change)="onComposeFiles($event)">
          Csatolás
        </label>
        <span class="sml-reply__note">{{ settings?.signature ? 'Az aláírás automatikusan a levél végére kerül.' : '' }}</span>
        <button type="button" class="sml-btn sml-btn--sm" (click)="compose = null" [disabled]="sending">Mégse</button>
        <button type="submit" class="sml-btn sml-btn--sm sml-btn--primary" [disabled]="sending">{{ sending ? 'Küldés…' : 'Küldés' }}</button>
      </div>
    </form>
  </div>

  <!-- Partnerek (címjegyzék) -->
  <div class="sml-overlay" *ngIf="partnersOpen">
    <div class="sml-modal">
      <div class="sml-modal__head">
        <span class="sml-modal__title">Partnerek</span>
        <span class="sml-modal__from">Futárok, beszállítók — akiknek rendszeresen innen írtok</span>
        <button type="button" class="sml-icon-btn" title="Bezárás" (click)="partnersOpen = false">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
        </button>
      </div>
      <div class="sml-modal__body">
        <button type="button" class="sml-btn sml-btn--block" *ngIf="!partnerForm" (click)="editPartner()">+ Új partner</button>
        <form class="sml-task" *ngIf="partnerForm" (ngSubmit)="savePartnerForm()">
          <div class="sml-form__grid">
            <label class="sml-field"><span>Név</span>
              <input class="sml-input sml-input--sm" name="pName" [(ngModel)]="partnerForm.name" placeholder="UPS" maxlength="255" autocomplete="off"></label>
            <label class="sml-field"><span>E-mail <em>(vagy &#64;domain a teljes céghez)</em></span>
              <input class="sml-input sml-input--sm" name="pEmail" [(ngModel)]="partnerForm.email" placeholder="ugyfelszolgalat@ups.com vagy &#64;ups.com" autocomplete="off"></label>
          </div>
          <label class="sml-field" style="margin-top: 8px"><span>Megjegyzés <em>(nem kötelező)</em></span>
            <input class="sml-input sml-input--sm" name="pNote" [(ngModel)]="partnerForm.note" placeholder="pl. kárigények, ügyfélszám: …" maxlength="500" autocomplete="off"></label>
          <div class="sml-task__actions">
            <button type="button" class="sml-btn sml-btn--sm" (click)="partnerForm = null" [disabled]="partnerSaving">Mégse</button>
            <button type="submit" class="sml-btn sml-btn--sm sml-btn--primary" [disabled]="partnerSaving || !partnerForm.name.trim() || !partnerForm.email.trim()">{{ partnerSaving ? 'Mentés…' : 'Mentés' }}</button>
          </div>
        </form>

        <div class="sml-link-item" *ngFor="let p of partners">
          <div class="sml-link-item__row">
            <span class="sml-avatar sml-avatar--sm" [style.background]="colorOf(p.name)">{{ initialOf(p.name) }}</span>
            <div class="sml-link-item__main sml-link-item__main--plain">
              <div class="sml-link-item__title">{{ p.name }}</div>
              <div class="sml-link-item__meta">{{ p.email }}{{ p.note ? ' · ' + p.note : '' }}</div>
            </div>
            <button type="button" class="sml-btn sml-btn--sm" *ngIf="!p.email.startsWith('@')" [disabled]="!settings?.configured" (click)="openCompose(p.email)">Levél</button>
            <button type="button" class="sml-icon-btn" title="Szerkesztés" (click)="editPartner(p)">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20 l4 -1 l11 -11 a1.5 1.5 0 0 0 0 -2.2 l-0.8 -0.8 a1.5 1.5 0 0 0 -2.2 0 L5 16 z"></path></svg>
            </button>
            <button type="button" class="sml-icon-btn" title="Törlés" (click)="removePartner(p)">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
            </button>
          </div>
        </div>
        <div class="sml-empty" *ngIf="!partners.length && !partnerForm">Még nincs partner. Vedd fel a futárokat és beszállítókat (UPS, Spring GDS…), hogy új levélnél egy kattintással kiválaszthasd őket.</div>
        <div class="sml-box__hint">A partnerekkel folytatott nyitott levelezés a lista <strong>Partnerek</strong> szűrőjével külön nézhető. Beszélgetésből is menthetsz partnert (jobb oldalt, a névjegynél), új levélnél pedig a címzettet.</div>
      </div>
    </div>
  </div>

  <!-- Postafiók beállítások -->
  <div class="sml-overlay" *ngIf="settingsForm">
    <form class="sml-modal sml-modal--wide" (ngSubmit)="saveSettings()">
      <div class="sml-modal__head">
        <span class="sml-modal__title">Support postafiók</span>
        <button type="button" class="sml-icon-btn" title="Bezárás" (click)="settingsForm = null" [disabled]="settingsSaving">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
        </button>
      </div>
      <div class="sml-modal__body">
        <div class="sml-form__grid">
          <label class="sml-field"><span>E-mail cím</span>
            <input class="sml-input" name="sEmail" [(ngModel)]="settingsForm.email" [placeholder]="purchasing ? 'beszerzes@bgfox.hu' : 'support@bgfox.hu'" autocomplete="off"></label>
          <label class="sml-field"><span>Feladó neve</span>
            <input class="sml-input" name="sFromName" [(ngModel)]="settingsForm.from_name" [placeholder]="purchasing ? 'BGFox Beszerzés' : 'BGFox Support'" autocomplete="off"></label>
          <label class="sml-field"><span>Felhasználónév <em>(üresen = az e-mail cím)</em></span>
            <input class="sml-input" name="sUser" [(ngModel)]="settingsForm.username" autocomplete="off"></label>
          <label class="sml-field"><span>Jelszó <em *ngIf="settings?.has_password">(mentve — csak cseréhez írd be)</em></span>
            <input class="sml-input" type="password" name="sPass" [(ngModel)]="settingsForm.password" autocomplete="new-password"
                   [placeholder]="settings?.has_password ? '••••••••' : ''"></label>
        </div>

        <div class="sml-form__section">Fogadás (IMAP)</div>
        <div class="sml-form__grid sml-form__grid--server">
          <label class="sml-field"><span>Szerver</span>
            <input class="sml-input" name="sImapHost" [(ngModel)]="settingsForm.imap_host" placeholder="mail.bgfox.hu" autocomplete="off"></label>
          <label class="sml-field"><span>Port</span>
            <input class="sml-input" name="sImapPort" [(ngModel)]="settingsForm.imap_port" placeholder="993" inputmode="numeric"></label>
          <label class="sml-check"><input type="checkbox" name="sImapSecure" [(ngModel)]="settingsForm.imap_secure"> SSL/TLS (993)</label>
        </div>

        <div class="sml-form__section">Küldés (SMTP)</div>
        <div class="sml-form__grid sml-form__grid--server">
          <label class="sml-field"><span>Szerver</span>
            <input class="sml-input" name="sSmtpHost" [(ngModel)]="settingsForm.smtp_host" placeholder="mail.bgfox.hu" autocomplete="off"></label>
          <label class="sml-field"><span>Port</span>
            <input class="sml-input" name="sSmtpPort" [(ngModel)]="settingsForm.smtp_port" placeholder="587" inputmode="numeric"></label>
          <label class="sml-check"><input type="checkbox" name="sSmtpSecure" [(ngModel)]="settingsForm.smtp_secure"> SSL/TLS (465) — 587-nél kikapcsolva</label>
        </div>
        <div class="sml-box__hint">Ajánlott port: <strong>587</strong> (STARTTLS, ugyanúgy titkosított). A 465-ös kimenő portot a tárhely zárja — azzal a küldés időtúllépésre fut.</div>

        <div class="sml-form__section">Aláírás</div>
        <textarea class="sml-input" name="sSignature" rows="5" [(ngModel)]="settingsForm.signature"
                  [placeholder]="signaturePlaceholder"></textarea>
        <div class="sml-box__hint">Minden kimenő levél végére kerül. A <code>{{ nameToken }}</code> helyére a küldő kolléga neve kerül; HTML aláírás is megadható (pl. logóval).</div>

        <label class="sml-check sml-check--main"><input type="checkbox" name="sEnabled" [(ngModel)]="settingsForm.enabled"> Új levelek automatikus fogadása percenként</label>

        <div class="sml-test" *ngIf="settingsTesting">Kapcsolat ellenőrzése…</div>
        <div class="sml-test" *ngIf="testResult">
          <div [class.sml-test--ok]="!testResult.imap" [class.sml-test--bad]="testResult.imap">Fogadás (IMAP): {{ testResult.imap || 'rendben' }}</div>
          <div [class.sml-test--ok]="!testResult.smtp" [class.sml-test--bad]="testResult.smtp">Küldés (SMTP): {{ testResult.smtp || 'rendben' }}</div>
        </div>
      </div>
      <div class="sml-modal__foot">
        <button type="button" class="sml-btn sml-btn--sm" (click)="saveSettings(true)" [disabled]="settingsSaving || settingsTesting">Mentés és kapcsolat-teszt</button>
        <span class="sml-reply__note"></span>
        <button type="button" class="sml-btn sml-btn--sm" (click)="settingsForm = null" [disabled]="settingsSaving">Mégse</button>
        <button type="submit" class="sml-btn sml-btn--sm sml-btn--primary" [disabled]="settingsSaving">{{ settingsSaving ? 'Mentés…' : 'Mentés' }}</button>
      </div>
    </form>
  </div>
</div>
